import type { ModalStatelessProps } from '@/components/ModalStateless';
import { ConfirmationModal } from '@/components/molecules/ConfirmationModal';
import { useMessages } from '@/hooks/messages';

import { estimationDetailEstimationItemDeleteModalMessageDefinitions } from './messages';

type DeleteEstimationItemModalProps = Pick<ModalStatelessProps, 'open' | 'onClose'> & {
  onConfirm: () => void;
};

export const DeleteEstimationItemModal: React.FC<DeleteEstimationItemModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const messages = useMessages(estimationDetailEstimationItemDeleteModalMessageDefinitions);

  return (
    <ConfirmationModal
      title={messages.title()}
      warningMessage={messages.warningMessage()}
      confirmButtonLabel={messages.confirmButton()}
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};
